// extracted by mini-css-extract-plugin
export default {"fallbackLoader":"FallbackLoader_fallbackLoader__1cyPx","loader":"FallbackLoader_loader__S8AHN"};